import React from 'react'
import { useShallow } from 'zustand/react/shallow'

import { TextHero } from '../components/TextHero'
import { Wizard } from '../components/Wizard'
import { WizardCTA } from '../components/WizardCTA'
import { useNavigationStore } from '../state/navigationStore'

const StartScreen = () => {
  const { navigateScreen, wizardOpen, setWizardOpen } = useNavigationStore(
    useShallow((state) => ({
      navigateScreen: state.navigateScreen,
      wizardOpen: state.wizardOpen,
      setWizardOpen: state.setWizardOpen,
    }))
  )

  return (
    <div className='start-screen'>
      <div className='start-screen__content'>
        <TextHero centered />

        {!wizardOpen ? (
          <>
            <WizardCTA />

            <p className='start-screen__text'>
              If you prefer viewing and filtering the systems and case studies
              manually, go directly to the listings view.
            </p>

            <button
              className='start-screen__list-btn'
              onClick={() => navigateScreen('list')}
            >
              <span>View and filter manually</span>
              <i className='fa-solid fa-arrow-right'></i>
            </button>
          </>
        ) : (
          <>
            <div className='start-screen__wizard-wrapper'>
              <Wizard />
            </div>

            <button
              className='start-screen__skip-wizard-btn'
              onClick={() => {
                setWizardOpen(false)
                navigateScreen('list')
              }}
            >
              <span>Skip and view results</span>
              <i className='fa-solid fa-arrow-right'></i>
            </button>
          </>
        )}
      </div>
    </div>
  )
}

export { StartScreen }
